var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaintenanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6239 7.11411C17.3635 7.37967 17.2177 7.73672 17.2177 8.10858C17.2177 8.48045 17.3635 8.83749 17.6239 9.10306L19.8969 11.3762C20.1625 11.6365 20.5196 11.7823 20.8914 11.7823C21.2633 11.7823 21.6203 11.6365 21.8859 11.3762L27.2419 6.02018C27.9562 7.59883 28.1725 9.35769 27.8619 11.0624C27.5513 12.7671 26.7286 14.3366 25.5033 15.5619C24.2781 16.7871 22.7085 17.6099 21.0039 17.9205C19.2992 18.2311 17.5403 18.0148 15.9617 17.3004L6.14474 27.1173C5.57956 27.6825 4.81301 28 4.01372 28C3.21443 28 2.44788 27.6825 1.8827 27.1173C1.31752 26.5521 1 25.7856 1 24.9863C1 24.187 1.31752 23.4204 1.8827 22.8553L11.6996 13.0383C10.9852 11.4597 10.7689 9.70083 11.0795 7.99614C11.3901 6.29145 12.2129 4.7219 13.4381 3.49665C14.6634 2.27141 16.2329 1.44867 17.9376 1.13807C19.6423 0.827469 21.4012 1.04377 22.9798 1.75814L17.6381 7.0999L17.6239 7.11411Z",
    stroke: "#14142B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceIcon);
export default __webpack_public_path__ + "static/media/maintenanceIcon.e82853c1957dfec5c1c4ece9fc05e699.svg";
export { ForwardRef as ReactComponent };